export default __webpack_public_path__ + "static/media/jstar.1e238f4d.png";